exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card_animate[data-v-40c9c0ea]{overflow:hidden;-webkit-transition:.5s;transition:.5s}.text-primary-cus[data-v-40c9c0ea]{color:var(--systemMainColor)}[data-v-40c9c0ea] .el-card__body{height:100%;padding:10px}", ""]);

// exports
